document.addEventListener('teeinblue-event-component-injected', function() {
  const teeinblueATCBtn = document.getElementById('teeAtcButton');
  
  if (teeinblueATCBtn) {
    // Prevent 3rd app (Sticky Add To Cart BOOSTER PRO) to listen an action of teeinblue ATC button
    teeinblueATCBtn.addEventListener('click', function(e) {
      e.stopImmediatePropagation();
      console.log('clicked teeinblue ATC button');
    });
  }
});